import { ListItemText, Menu, MenuItem, useTheme } from '@mui/material';
import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';

interface FormDetailActionsMenuProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  onArchive: () => void;
  onAuditLog: () => void;
  onUnpublish?: () => void;
  showEdit: boolean;
  showArchive: boolean;
  showAuditLog: boolean;
  showUnpublish?: boolean;
  archiveDisabled: boolean;
}

export const FormDetailActionsMenu = ({
  anchorEl,
  open,
  onClose,
  onEdit,
  onArchive,
  onAuditLog,
  onUnpublish,
  showEdit,
  showArchive,
  showAuditLog,
  showUnpublish = false,
  archiveDisabled,
}: FormDetailActionsMenuProps) => {
  const { presets } = useTheme<LensTheme>();
  const bottomRight =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (presets as any)?.MenuPresets?.positionFromAnchorEl?.bottomRight ?? {};
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{ list: { 'aria-label': 'More actions' } }}
      data-testid="form-detail-actions-menu"
      {...bottomRight}
    >
      {showEdit && (
        <MenuItem
          onClick={onEdit}
          data-testid="form-detail-menu-edit"
          divider={showUnpublish || showArchive || showAuditLog}
        >
          <ListItemText>Edit</ListItemText>
        </MenuItem>
      )}
      {showUnpublish && (
        <MenuItem
          onClick={onUnpublish}
          data-testid="form-detail-menu-unpublish"
          divider={showArchive || showAuditLog}
        >
          <ListItemText>Unpublish</ListItemText>
        </MenuItem>
      )}
      {showArchive && (
        <MenuItem
          onClick={onArchive}
          disabled={archiveDisabled}
          data-testid="form-detail-menu-archive"
          divider={showAuditLog}
        >
          <ListItemText>Archive</ListItemText>
        </MenuItem>
      )}
      {showAuditLog && (
        <MenuItem onClick={onAuditLog} data-testid="form-detail-menu-audit-log">
          <ListItemText>Audit log</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};
